<template>
  <div id="app" style="padding-bottom: 98px">
    <div class="theheaderBox">
      <div class="headerBox">
        <div class="hd1">
          <img src="../static/resource/logo.png" alt="" style="float: left;"/>
        </div>
        <div class="hd2" style="font-family:'Microsoft YaHei';">
          <router-link class="router-link-class" to="/FirstPage" exact-active-class="topActive"><span>首页</span>
          </router-link>
          <router-link class="router-link-class" to="/NewsPage" active-class="topActive"><span>资讯热点</span>
          </router-link>
          <router-link class="router-link-class" to="/FilmgraphyPage" active-class="topActive"><span>影视作品</span>
          </router-link>
          <router-link class="router-link-class" to="/FirstPage#cooperPosion" active-class="topActive"><span>合作艺人</span>
          </router-link>
          <router-link class="router-link-class" to="/FirstPage#aboutPosion" active-class="topActive"><span>关于萌样</span>
          </router-link>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
  export default {
    name: 'App',
    data: function () {
      return {
        select: 0
      }
    },
    methods: {}
  }
</script>

<style>
  #app {
    font-family: "Microsoft YaHei" !important;
  }

  .topActive {
    color: #74e4ff;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: black;
  }

  .hd1 {
    height: 48px;
    line-height: 48px;
    width: 40%;
    float: left;
    text-align: center;
  }

  .hd1 > img {
    height: 48px;
    width: auto;
  }

  .hd2 {
    height: 48px;
    line-height: 48px;
    width: 60%;
    float: left;
    color: #666666;
  }

  .hd2 .router-link-class {
    font-size: 22px;
    margin-left: 50px;
  }

  .hd2 .router-link-class:hover {
    color: #74e4ff
  }

  .hd2 span a:hover {
    cursor: pointer;
    color: #74e4ff
  }

  .theheaderBox {
    height: 60px;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000000;
    background-color: white;
    line-height: 60px;
    -moz-box-shadow: 0px 5px 8px #e2e2e2;
    -webkit-box-shadow: 0px 5px 8px #e2e2e2;
    box-shadow: 0px 5px 8px #e2e2e2;
  }

  .headerBox {
    height: 48px;
    width: 1204px;
    margin: 6px auto;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*overflow: auto;*/
    /*height: 100%;*/
  }
</style>




















// WEBPACK FOOTER //
// src/App.vue